export const defaultLanguage = "tk";

export const languages = [
	{ iso: "en", name: "English" },
	{ iso: "ru", name: "Русский" },
	{ iso: "tk", name: "Türkmen" },
]